import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeTableCar1 } from '../models/TypeTableCar1';
import { TR } from '../models/TR';
import { Step3 } from '../../../../shared/models/component-messages/mapaIN/step3';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';

@Component({
  selector: 'app-type-table-car1',
  templateUrl: './type-table-car1.component.html'
})
export class TypeTableCar1Component implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeTableCar1';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() tabCar1: TypeTableCar1;

  public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
  }
  
  
  addtR(){
		this.tabCar1.tr.push(new TR());
	}
  
  removetR(i){
    ArrayPopTools.pop(this.tabCar1.tr, i, this.parentForm, this.getUid());
	}
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

